module.exports = __webpack_public_path__ + "img/nvzhuang.e89190dc.png";